export default {
  message: 'Broadcast message',
  logoutWarning: 'All users except Admins will be logged out after the maintenance mode is enabled',
  maintenanceModeIsOn: 'Maintenance mode is on',
};
